
import SourceItem from './source-item.vue'

export default {
  components: {SourceItem},
  inject: ['di_sources'],
  props: {
    text: {
      type: String,
      required: true, 
    },
    href: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cur_idx: 0,
      hover: false
    }
  },
  computed:{
    src_idxs(){
      const str = this.href.replace('sources://', '')
      return str.split(',').map(x => +x - 1)
    },
    sources(){
      return this.src_idxs.map(x => this.di_sources[x])
    },
    current(){
      return this.sources[this.cur_idx]
    },
  },
  methods: {
    setSource(next){
      if (next >= this.sources.length) {
        this.cur_idx = 0
        return
      }
      if (next < 0) {
        this.cur_idx = this.sources.length - 1
        return
      }
      this.cur_idx = next
    }
  }
}
